import { useQuery } from "@tanstack/react-query";

import {
  getFastenerBrands,
  searchFastenerCatalog,
  type FastenerBrandOption,
  type FastenerCatalogItem,
} from "../api/catalogs";
import type { FastenerBrandCode } from "../api/applications";

/** Brand dropdown options (GET /v1/filter-options/fastener-brands). */
export function useFastenerBrands() {
  return useQuery<FastenerBrandOption[]>({
    queryKey: ["filter-options", "fastener-brands"],
    queryFn: getFastenerBrands,
    staleTime: 10 * 60 * 1000,
  });
}

/**
 * Fastener-type options for a brand (GET /v1/catalogs/fasteners?brand=&limit=20).
 * Disabled for OTHER (no catalog source — free text) and when no brand is set.
 */
export function useFastenerCatalog(brand: FastenerBrandCode | null | undefined, q = "") {
  return useQuery<FastenerCatalogItem[]>({
    queryKey: ["catalogs", "fasteners", brand, q],
    queryFn: () => searchFastenerCatalog({ brand: brand as FastenerBrandCode, q: q || undefined, limit: 20 }),
    enabled: !!brand && brand !== "OTHER",
    staleTime: 60 * 1000,
  });
}
